import * as React from 'react';
import { ReactComponent as PictureIcon } from 'assets/icons/picture.svg';
import { ContainerType, ShippingLine, SnapshotUrl } from 'types/Shipping';
import { useRegion } from 'common/hooks/region';
import { formatDateTime } from 'services/helpers/format-date';
import classNames from 'classnames';
import { PerDiem } from './types';
import { PerDiemWording } from './PerDiemWording';

interface Props {
  selected: string | undefined;
  setSelected: (key: string) => void;
  orderedPerDiem: PerDiem[];
  snapshotUrl?: SnapshotUrl;
  shippingLines: ShippingLine[];
  containerTypes: ContainerType[];
}

const Label: React.FC<{ children: React.ReactNode; selected: boolean }> = ({
  children,
  selected,
}) => (
  <h4
    className={classNames('cursor-pointer opacity-50 ml-3 mt-3 hover:opacity-70', {
      'font-bold !opacity-100': selected,
    })}
  >
    {children}
  </h4>
);

const Bullet: React.FC<{ selected: boolean }> = ({ selected }) => (
  <div
    className={classNames(
      'w-[10px] h-[10px] rounded-full border border-gray-500 bg-white absolute left-[-5px] top-[5px]',
      {
        'bg-gray-600 !w-[20px] !h-[20px] left-[-10px] top-[-0px]': selected,
      }
    )}
  />
);

export const PerDiemList: React.FC<Props> = (props) => {
  const { selected, setSelected, orderedPerDiem, snapshotUrl, shippingLines, containerTypes } =
    props;
  const region = useRegion();

  return (
    <div className="border-l border-gray-500 ">
      {orderedPerDiem.map((pd) => (
        <div className="relative" key={pd.key} onClick={() => setSelected(pd.key)}>
          <Bullet selected={pd.key === selected} />
          <Label selected={pd.key === selected}>
            <PictureIcon style={{ marginRight: 10 }} />
            <PerDiemWording
              shippingLines={shippingLines}
              containerTypes={containerTypes}
              perDiem={pd}
            />
          </Label>
        </div>
      ))}
      {snapshotUrl && (
        <div className="relative" onClick={() => setSelected(snapshotUrl.key as string)}>
          <Bullet selected={snapshotUrl.key === selected} />
          <Label selected={snapshotUrl.key === selected}>
            {snapshotUrl.time
              ? `${formatDateTime(
                  snapshotUrl.date,
                  // Time is sent in PST from the BE since terminal screenshots are saved in PST
                  `${snapshotUrl.time}-07:00`,
                  region.timeZone
                )}: terminal instructions`
              : 'Not available'}
          </Label>
        </div>
      )}
    </div>
  );
};
PerDiemList.displayName = 'TerminalScreenshots.TimeRangeContent.PerDiemList';
